import {Component, OnInit} from '@angular/core';
import {HierarchyNodeService} from '../hierarchy-node.service';
import {HierarchyNodeModel} from '../models/hierarchy-node.model';
import {cloneDeep} from "lodash-es";
import {BaseModalComponent} from "common-shared";
import {takeUntil} from "rxjs/operators";

@Component({
  selector: 'mes-web-hierarchy-node-edit-modal',
  templateUrl: './hierarchy-node-edit-modal.component.html'
})
export class HierarchyNodeEditModalComponent extends BaseModalComponent implements OnInit {
  selectedIds: string[];
  nodes: HierarchyNodeModel[] = [];
  initialNodes: HierarchyNodeModel[];
  readonly = false;
  rootNode: HierarchyNodeModel;

  constructor(private hierarchyNodeService: HierarchyNodeService) {
    super();
  }

  ngOnInit() {
    this.hierarchyNodeService.getRootWithHierarchy().pipe(takeUntil(this.componentDestroyed)).subscribe(root => {
      this.rootNode = root;
      this.nodes = this.hierarchyNodeService.flatten([...root.Children]);
      this.nodes.map(node => {
        if (this.selectedIds.includes(node.Id)) {
          node.IsSelected = true;
        }
        node.IsExpanded = true;
      });

      this.initialNodes = cloneDeep(this.nodes);
    });
  }

  ensureSaveChanges(node: HierarchyNodeModel) {
    const initialNode = this.initialNodes.find(initialNode => initialNode.Id === node.Id);
    if (initialNode?.Name !== node.Name) {
      this.hierarchyNodeService.getNodeWithHierarchy(initialNode.Id).pipe(takeUntil(this.componentDestroyed)).subscribe(value => {
        value.Name = node.Name;
        this.hierarchyNodeService.save(value).pipe(takeUntil(this.componentDestroyed)).subscribe(() => initialNode.Name = node.Name);
      });
    }
  }

  onSelect($event: { checked: boolean }, node: HierarchyNodeModel) {
    node.IsSelected = $event.checked;
    this.selectedIds = this.nodes.filter(n => n.IsSelected).map(n => n.Id);
  }

  addChild(parent: HierarchyNodeModel): void {
    this.hierarchyNodeService.addNew(new HierarchyNodeModel({
      Name: 'New child',
      ParentId: parent.Id
    })).pipe(takeUntil(this.componentDestroyed)).subscribe(newChild => {
      parent.Children = [...parent.Children || [], newChild];
      this.nodes = [...this.nodes, newChild];
      this.initialNodes.push(cloneDeep(newChild));
    });
  }

  remove(node: HierarchyNodeModel): void {
    this.hierarchyNodeService.delete(node.Id).pipe(takeUntil(this.componentDestroyed)).subscribe(() => {
      const parentNode = this.nodes.find(n => n.Id === node.ParentId);
      if (parentNode) {
        parentNode.Children = parentNode.Children.filter(n => n.Id !== node.Id);
      }
      this.nodes = this.nodes.filter(n => n.Id !== node.Id);
    });
  }
}
